import { z } from 'zod'
import {
  abstractComponent,
  COMPONENT_TYPES,
} from '@customTypes/cloudmix/sessions/components/base'
import { audioVideoOutputPadWithFallbackSchema } from '@customTypes/cloudmix/sessions/pads'

export const liveInputSourceComponentSchema = abstractComponent.extend({
  type: z
    .literal(COMPONENT_TYPES.liveInputSource)
    .default(COMPONENT_TYPES.liveInputSource),
  liveInputId: z.string().min(1, 'Live input ID is required'),
  output: audioVideoOutputPadWithFallbackSchema,
})

export const projectLiveInputSourceComponentSchema =
  liveInputSourceComponentSchema
export type ProjectLiveInputSourceComponent = z.infer<
  typeof projectLiveInputSourceComponentSchema
>
